import axiosInstance from "../Utils/axiosInstance";
import { AreaApi } from "../Constants/api";

export const getAreasApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${AreaApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
